import { computed } from 'vue'
import type { ComputedRef } from 'vue'
// types
import type { StrapiHeaderTopItem } from '@ts-strapi/interfaces'
// constants
import { STRAPI_HEADER_ITEM_TYPE } from '@ts-strapi/enums'

export interface HeaderDesktopNavItemProps {
  item: StrapiHeaderTopItem
  isOpen: boolean
}

interface HeaderDesktopNavItemOptions {
  props: HeaderDesktopNavItemProps
  onOpen: () => void
  onClose: () => void
}

interface HeaderDesktopNavItemReturn {
  refIsMega: ComputedRef<boolean>
  handleMouseEnter: () => void
  handleMouseLeave: () => void
  handleClick: () => void
}

export const useHeaderDesktopNavItem = ({ props, onOpen, onClose }: HeaderDesktopNavItemOptions): HeaderDesktopNavItemReturn => {
  const refIsMega = computed<boolean>(() =>
    props.item.__component === STRAPI_HEADER_ITEM_TYPE.MultipleMenu
    || props.item.__component === STRAPI_HEADER_ITEM_TYPE.SingleMenu,
  )

  const handleMouseEnter = (): void => {
    if (refIsMega.value) onOpen()
  }

  const handleMouseLeave = (): void => {
    if (refIsMega.value) onClose()
  }

  const handleClick = (): void => {
    if (props.isOpen) onClose()
    else onOpen()
  }

  return {
    refIsMega,
    handleMouseEnter,
    handleMouseLeave,
    handleClick,
  }
}
